/**
 * Virtual-position id scheme.
 *
 * Kept as a dependency-free leaf module so pure logic (e.g. shift-closing move calculations) can
 * import these helpers without pulling in the heavy `PositionName` component graph (MUI, the
 * `@sinch/components` barrel, i18n). Importing UI here would make unit tests load the whole UI tree.
 */

/** Prefix marking a position id that exists only client-side and is not yet persisted to the server. */
export const VIRTUAL_POSITION_PREFIX = "__virtual";

const NEW_POSITION_PREFIX = `${VIRTUAL_POSITION_PREFIX}:`;

/** True when the id refers to a position created in the UI (e.g. during shift closing) and not yet saved. */
export const isNewPositionId = (positionId: string): boolean => positionId.startsWith(NEW_POSITION_PREFIX);
